/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ProductionPlanCreatePage = lazyLoad(
  () => import('./index'),
  module => module.ProductionPlanCreatePage
);
